export default __webpack_public_path__ + "static/media/ic_phone_call_green.d62bbcb3.svg";